import { AxiosError, AxiosResponse } from 'axios';
import { GET_USER_DETAILS_URL } from '../../constants/apiUrls';
import { GET_USER_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import { OrganisationModuleAccess } from '../../models';
import { useAppDispatch } from '../../store';
import { updateCsrfToken } from '../../store/appSlice';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface UserDetailsResponse {
  roles?: string[];
  organisationAccess?: OrganisationModuleAccess[];
  displayName?: string;
  csrfToken: string;
  organisationName?: string;
  inactivityMinutes?: number;
  credentialType: string;
  serverDateTime?: string;
  photoURL?: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  enabled?: boolean;
  onSuccess?: (data: AxiosResponse<UserDetailsResponse>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetUserDetails = (input: Input = { enabled: true }) => {
  const { enabled = true, onSuccess, onError } = input;
  const dispatch = useAppDispatch();
  const getUserDetails = async () => axiosClient.get<UserDetailsResponse>(GET_USER_DETAILS_URL);

  return useCustomQuery(
    [GET_USER_DETAILS_QUERY_KEY],
    getUserDetails,
    {
      onSuccess: (res) => {
        // dispatch csrf token to store is to be called for every getUserDetails
        dispatch(updateCsrfToken(res.data.csrfToken));

        onSuccess?.(res);
      },
      onError,
      staleTime: Infinity,
      retry: false,
      enabled,
    },
    false
  );
};
